import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCrunchyrollComponent } from './simple-icons-crunchyroll.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCrunchyrollComponent ],
    exports:      [ SimpleIconsCrunchyrollComponent ],
    bootstrap:    []
})
export class SimpleIconsCrunchyrollModule {}
